import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-huodong",
  "use": "icon-huodong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-huodong\"><path fill=\"#ffffff\" d=\"M621.7216 85.333333V68.266667a51.2 51.2 0 0 0-51.2-51.2H153.6a68.266667 68.266667 0 0 0-68.266667 68.266666v870.4a51.2 51.2 0 1 0 102.4 0V631.466667a68.266667 68.266667 0 0 1 68.266667-68.266667h163.345067a51.2 51.2 0 0 1 51.2 51.2v17.066667a51.2 51.2 0 0 0 51.2 51.2H870.4a68.266667 68.266667 0 0 0 68.266667-68.266667V204.8a68.266667 68.266667 0 0 0-68.266667-68.266667H672.9216a51.2 51.2 0 0 1-51.2-51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/huodong.svg
// module id = +bD3
// module chunks = 65